// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BUY_IN_ESHOP = "K\u00fapi\u0165 v eshope ";
export const BUY_IN_MK_ESHOP = "K\u00fapi\u0165 v eshope Modr\u00e9ho kon\u00edka";
export const IN_MK_ESHOP = "Modr\u00e9ho kon\u00edka";
export const SHOPPING_WITH_MK = "Nakupuj s Modr\u00fdm kon\u00edkom";
